import { Box, Skeleton, Grid } from "@mui/material";

const TableLoader = () => {
  return (
    <Box p={3}>
      <Grid container spacing={3}>
        <Grid item xs={12} md={3}>
          <Skeleton variant="rectangular" fullWidth />
        </Grid>
        <Grid item xs={12} md={3}>
          <Skeleton variant="rectangular" fullWidth />
        </Grid>
        <Grid item xs={12} md={3}>
          <Skeleton variant="rectangular" fullWidth />
        </Grid>
        <Grid item xs={12} md={3}>
          <Skeleton variant="rectangular" fullWidth />
        </Grid>
        <Grid item xs={12} md={3}>
          <Skeleton variant="rectangular" fullWidth />
        </Grid>
        <Grid item xs={12} md={3}>
          <Skeleton variant="rectangular" fullWidth />
        </Grid>
        <Grid item xs={12} md={3}>
          <Skeleton variant="rectangular" fullWidth />
        </Grid>
        <Grid item xs={12} md={3}>
          <Skeleton variant="rectangular" fullWidth />
        </Grid>
        <Grid item xs={12} md={3}>
          <Skeleton variant="rectangular" fullWidth />
        </Grid>
        <Grid item xs={12} md={3}>
          <Skeleton variant="rectangular" fullWidth />
        </Grid>
        <Grid item xs={12} md={3}>
          <Skeleton variant="rectangular" fullWidth />
        </Grid>
        <Grid item xs={12} md={3}>
          <Skeleton variant="rectangular" fullWidth />
        </Grid>
        <Grid item xs={12} md={3}>
          <Skeleton variant="rectangular" fullWidth />
        </Grid>
        <Grid item xs={12} md={3}>
          <Skeleton variant="rectangular" fullWidth />
        </Grid>
        <Grid item xs={12} md={3}>
          <Skeleton variant="rectangular" fullWidth />
        </Grid>
        <Grid item xs={12} md={3}>
          <Skeleton variant="rectangular" fullWidth />
        </Grid>
        <Grid item xs={12} md={3}>
          <Skeleton variant="rectangular" fullWidth />
        </Grid>
        <Grid item xs={12} md={3}>
          <Skeleton variant="rectangular" fullWidth />
        </Grid>
        <Grid item xs={12} md={3}>
          <Skeleton variant="rectangular" fullWidth />
        </Grid>
        <Grid item xs={12} md={3}>
          <Skeleton variant="rectangular" fullWidth />
        </Grid>
        <Grid item xs={12} md={3}>
          <Skeleton variant="rectangular" fullWidth />
        </Grid>
        <Grid item xs={12} md={3}>
          <Skeleton variant="rectangular" fullWidth />
        </Grid>
        <Grid item xs={12} md={3}>
          <Skeleton variant="rectangular" fullWidth />
        </Grid>
        <Grid item xs={12} md={3}>
          <Skeleton variant="rectangular" fullWidth />
        </Grid>
        <Grid item xs={12} md={3}>
          <Skeleton variant="rectangular" fullWidth />
        </Grid>
        <Grid item xs={12} md={3}>
          <Skeleton variant="rectangular" fullWidth />
        </Grid>
        <Grid item xs={12} md={3}>
          <Skeleton variant="rectangular" fullWidth />
        </Grid>
        <Grid item xs={12} md={3}>
          <Skeleton variant="rectangular" fullWidth />
        </Grid>
        <Grid item xs={12} md={3}>
          <Skeleton variant="rectangular" fullWidth />
        </Grid>
        <Grid item xs={12} md={3}>
          <Skeleton variant="rectangular" fullWidth />
        </Grid>
        <Grid item xs={12} md={3}>
          <Skeleton variant="rectangular" fullWidth />
        </Grid>
        <Grid item xs={12} md={3}>
          <Skeleton variant="rectangular" fullWidth />
        </Grid>
        <Grid item xs={12} md={3}>
          <Skeleton variant="rectangular" fullWidth />
        </Grid>
        <Grid item xs={12} md={3}>
          <Skeleton variant="rectangular" fullWidth />
        </Grid>
        <Grid item xs={12} md={3}>
          <Skeleton variant="rectangular" fullWidth />
        </Grid>
        <Grid item xs={12} md={3}>
          <Skeleton variant="rectangular" fullWidth />
        </Grid>
        <Grid item xs={12} md={3}>
          <Skeleton variant="rectangular" fullWidth />
        </Grid>
        <Grid item xs={12} md={3}>
          <Skeleton variant="rectangular" fullWidth />
        </Grid>
        <Grid item xs={12} md={3}>
          <Skeleton variant="rectangular" fullWidth />
        </Grid>
        <Grid item xs={12} md={3}>
          <Skeleton variant="rectangular" fullWidth />
        </Grid>
        <Grid item xs={12} md={3}>
          <Skeleton variant="rectangular" fullWidth />
        </Grid>
        <Grid item xs={12} md={3}>
          <Skeleton variant="rectangular" fullWidth />
        </Grid>
        <Grid item xs={12} md={3}>
          <Skeleton variant="rectangular" fullWidth />
        </Grid>
        <Grid item xs={12} md={3}>
          <Skeleton variant="rectangular" fullWidth />
        </Grid>
      </Grid>
    </Box>
  );
};

export default TableLoader;
